import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';

export const Elements = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
`;

export const Description = styled.h3`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const Subtext = styled.p`
  font-size: 12px;
  color: ${COLORS.GRAY_TEXT};
`;

export const Content = styled.div`
  font-family: ${FONTS.OPEN_SANS};
`;